var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.toggleSwitch}}),_c('span',{class:{ 'slider': !_vm.isCheck, 'slide-right': _vm.isCheck }})])}
var staticRenderFns = []

export { render, staticRenderFns }